export default __webpack_public_path__ + "static/media/deal.3c5c2b32.mp3";